import React from 'react'
import { ResponsivePie } from '@nivo/pie'
import {
  // RGB_Linear_Shade, hexToRgb,
  generateColor
} from '../../../../helpers/utils'
import classes from './PieChart.scss'

const margin = { top: 30, right: 0, bottom: 30, left: 30 }

const outerSize = 337.5
const innerSize = 157.5

const styles = {
  root: {
    fontFamily: 'consolas, sans-serif',
    textAlign: 'center',
    position: 'relative',
    width: '100%',
    height: outerSize
  },
  overlay: {
    // color: 'red',
    position: 'absolute',
    top: 0,
    right: margin.right,
    bottom: 0,
    left: margin.left,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // fontSize: 96,
    textAlign: 'center'
    // pointerEvents: 'none'
  },
  overlayText: {
    position: 'absolute',
    top: 0,
    right: margin.right,
    bottom: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 35,
    color: '#000000',
    // background: "#FFFFFF33",
    textAlign: 'center',
    // This is important to preserve the chart interactivity
    pointerEvents: 'none'
  },
  totalLabel: {
    fontSize: 15
  },
  innerPie: {
    fontFamily: 'consolas, sans-serif',
    textAlign: 'center',
    position: 'relative',
    width: innerSize + 8,
    height: innerSize + 8,
    zIndex: 10
  }
}

const PieChart = ({ data, center, selectPerspective }) => {
  const { value: centerValue, label: centerLabel, color } = center
  const centerData = {
    value: centerValue,
    id: '',
    label: centerLabel,
    color
  }

  const colors = data.sort((a, b) => a.value - b.value).map(d => d.color)
  let colorGroup = colors.map((item, index) => {
    let gradient = generateColor(item, '#ffffff', 5)
    return {
      id: index,
      type: 'linearGradient',
      colors: gradient.map((col, index) => {
        return {
          offset: index * (100 / gradient.length - 1),
          color: `#${col}`
        }
      })
    }
  })
  let fill = [{ match: '*', id: 1 }]

  fill = colors.map((item, index) => {
    return {
      match: d => {
        return d.index === index
      },
      id: index
    }
  })

  const HorizontalTick = value => {
    let checkLength = value.label.length <= 16
    let middle = Math.floor(value.label.length / 2)
    if (checkLength) {
      return (
        <React.Fragment>
          <tspan x='0' dy='0'>
            {value.label}
          </tspan>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <tspan x='0' dy='-0.6em'>
            {value.label.slice(0, middle)}
          </tspan>
          <tspan x='0' dy='1.2em'>
            {value.label.slice(middle + 1)}
          </tspan>
        </React.Fragment>
      )
    }
  }
  return (
    <div className={classes.pieWrapper}>
      <div style={styles.root}>
        <div style={styles.overlay}>
          <div style={styles.innerPie}>
            <ResponsivePie
              onClick={() => selectPerspective('center')}
              data={[centerData]}
              innerRadius={0}
              colors={['white']}
              borderColor={'white'}
              borderWidth={2}
              slicesLabelsTextColor='#000'
              enableRadialLabels={false}
              enableSlicesLabels={false}
              margin={{ top: 8, right: 8, bottom: 8, left: 8 }}
              // tooltip={false}
              tooltip={({ id, value, label, color }) => (
                <strong style={{ color: 'white' }}>{`ทั้งหมด: ${parseFloat(value).toFixed(
                  2
                )}%`}</strong>
              )}
              // defs={[
              //   {
              //     id: 'all',
              //     type: 'linearGradient',
              //     colors: [
              //       {
              //         offset: 0,
              //         color: RGB_Linear_Shade(hexToRgb(color) || hexToRgb('#7FCCF0'), 0.5)
              //       },
              //       {
              //         offset: 20,
              //         color: RGB_Linear_Shade(hexToRgb(color) || hexToRgb('#7FCCF0'), 0.8)
              //       },
              //       { offset: 100, color: hexToRgb(color) || hexToRgb('#7FCCF0') }
              //     ]
              //   }
              // ]}
              // fill={[{ match: '*', id: 'all' }]}
              theme={{
                labels: {
                  text: {
                    fontSize: '16px'
                  }
                },
                tooltip: {
                  zIndex: 99999,
                  container: {
                    background: 'rgba(0, 0, 0, 0.6)',
                    minWidth: '100px',
                    borderRadius: '5px'
                  }
                }
              }}
            />
            <div style={styles.overlayText}>
              <span>{`${centerData.value}%`}</span>
              <span style={styles.totalLabel}>ทั้งหมด</span>
            </div>
          </div>
        </div>
        <ResponsivePie
          margin={margin}
          data={data}
          colors={colors}
          innerRadius={0.55}
          enableRadialLabels={true}
          enableSlicesLabels={true}
          slicesLabelsTextColor='#000'
          onClick={event => selectPerspective(event)}
          // radialLabel={HorizontalTick}
          radialLabel={HorizontalTick}
          sliceLabel={e => {
            return `${e.value}%`
          }}
          // margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
          // innerRadius={0.5}
          padAngle={0.7}
          cornerRadius={3}
          // colors={{ scheme: 'nivo' }}
          // borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
          radialLabelsSkipAngle={0}
          radialLabelsTextXOffset={0}
          radialLabelsTextColor='#333333'
          radialLabelsLinkOffset={0}
          radialLabelsLinkDiagonalLength={16}
          radialLabelsLinkHorizontalLength={11}
          radialLabelsLinkStrokeWidth={3}
          radialLabelsLinkColor={{ from: 'color' }}
          slicesLabelsSkipAngle={10}
          tooltip={({ id, value, label, color }) => (
            <strong style={{ color: 'white' }}>{`${label}: ${value}%`}</strong>
          )}
          defs={colorGroup}
          theme={{
            labels: {
              text: {
                fontSize: '14px'
              }
            },
            tooltip: {
              zIndex: 99999,
              container: {
                background: 'rgba(0, 0, 0, 0.6)',
                borderRadius: '5px'
              }
            }
          }}
          fill={fill}
          // slicesLabelsTextColor="#333333"
        />
      </div>
    </div>
  )
}

export default PieChart
